<template>
  <b-modal
    id="recommissionVehicleModal"
    size="md"
    content-class="sub-menu-bg-blue-transparent rcv-modal"
    title="Recommission Vehicle"
    hide-footer
    no-fade
    header-close-variant="light"
  >
    <div class="rcv-body" v-if="vehicle">

      <!-- Info strip -->
      <div class="rcv-info-strip">
        <fa :icon="['fas', 'check-circle']" class="rcv-info-icon" />
        <span>This will mark the vehicle as active again.</span>
      </div>

      <!-- Vehicle info card -->
      <div class="rcv-vehicle-card">
        <div class="rcv-vehicle-row">
          <span class="rcv-label">Vehicle</span>
          <span class="rcv-value">{{ vehicle.vehicle_name }}</span>
        </div>
        <div class="rcv-vehicle-row">
          <span class="rcv-label">Region</span>
          <span class="rcv-value">{{ vehicle.region }}</span>
        </div>
      </div>

      <!-- Confirmation text -->
      <p class="rcv-confirm-text">
        Vehicle <b class="rcv-highlight">{{ vehicle.vehicle_name }}</b> will be set back to
        <b class="rcv-highlight rcv-highlight--success">ACTIVE</b>.
        It will be moved back to the Active vehicles list.
      </p>

      <!-- Actions -->
      <div class="rcv-actions">
        <b-button class="rcv-confirm-btn" @click="submit()">
          Confirm Recommission
        </b-button>
      </div>

    </div>
  </b-modal>
</template>

<script>
import axios from 'axios'
export default {
  name: 'MMP_DPR_RecommissionVehicle',
  props: ['vehicle', 'user'],
  methods: {
    submit() {
      if (sessionStorage.token) {
        axios.put(process.env.API_LOCATION + '/api/dpr/recommissionVehicle', {
          id: this.vehicle.id,
          user: this.user.id
        }, {
          headers: { 'x-auth-token': sessionStorage.token }
        }).then(response => {
          const content = response.data
          if (content.errors) {
            this.$bvToast.toast(content.errors, {
              title: 'Recommission Error',
              variant: 'danger',
              toaster: 'b-toaster-top-right'
            })
          } else {
            this.$bvToast.toast(`${this.vehicle.vehicle_name} has been recommissioned.`, {
              title: 'Vehicle Recommissioned',
              variant: 'success',
              autoHideDelay: 5000,
              toaster: 'b-toaster-top-right'
            })
            this.$emit('refresh')
            this.$bvModal.hide('recommissionVehicleModal')
          }
        }).catch(error => console.log(error))
      } else {
        console.log('No User Token')
      }
    }
  }
}
</script>

<style scoped>
.rcv-body {
  padding: 4px 0 8px;
  display: flex;
  flex-direction: column;
  gap: 18px;
}

/* Info strip */
.rcv-info-strip {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 9px 13px;
  background: rgba(61, 201, 155, 0.1);
  border: 1px solid rgba(61, 201, 155, 0.3);
  border-left: 3px solid #3dc99b;
  border-radius: 6px;
  font-size: 13px;
  color: #1a7d59;
}
.rcv-info-icon {
  color: #3dc99b;
  flex-shrink: 0;
}

/* Vehicle info card */
.rcv-vehicle-card {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 12px 14px;
  background: rgba(6, 60, 109, 0.04);
  border: 1px solid rgba(6, 60, 109, 0.12);
  border-radius: 6px;
}
.rcv-vehicle-row {
  display: flex;
  align-items: baseline;
  gap: 12px;
}
.rcv-label {
  font-size: 11px;
  font-weight: 600;
  color: rgba(6, 60, 109, 0.6);
  letter-spacing: 0.07em;
  text-transform: uppercase;
  min-width: 60px;
}
.rcv-value {
  font-size: 13.5px;
  color: #063c6d;
  font-weight: 500;
}

/* Confirmation text */
.rcv-confirm-text {
  font-size: 13px;
  color: rgba(6, 60, 109, 0.7);
  line-height: 1.65;
  margin: 0;
}
.rcv-highlight {
  color: #063c6d;
  font-weight: 600;
}
.rcv-highlight--success {
  color: #3dc99b;
}

/* Actions */
.rcv-actions {
  display: flex;
  justify-content: center;
  padding-top: 4px;
}
.rcv-confirm-btn {
  background: rgba(61, 201, 155, 0.15) !important;
  border: 1px solid rgba(61, 201, 155, 0.4) !important;
  color: #3dc99b !important;
  font-weight: 600;
  padding: 8px 24px;
  border-radius: 6px;
  transition: background 0.15s;
  box-shadow: none !important;
}
.rcv-confirm-btn:hover {
  background: rgba(61, 201, 155, 0.28) !important;
}
</style>
